import { render, staticRenderFns } from "./MithelfenIcon.vue?vue&type=template&id=472c0547"
import script from "./MithelfenIcon.vue?vue&type=script&lang=js"
export * from "./MithelfenIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports